import { gql } from "@/gql/__generated__";
import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { useMutation } from "@apollo/client";

const SEND_FEEDBACK = gql(`
  mutation sendFeedback($message: String!, $whiteLabelConfigID: String){
    sendFeedback(input:  {
       message: $message
       whiteLabelConfigID: $whiteLabelConfigID
    }) {
      __typename
      email
    }
  }
`);

export function useSendFeedback() {
  const whiteLabelBrand = getWhiteLabelBrand();

  return useMutation(SEND_FEEDBACK, {
    variables: {
      message: "",
      whiteLabelConfigID: whiteLabelBrand?.configID
    }
  });
}
